import { useUiPreferences } from '../useUiPreferences';
import { ActionRow, Section, ToggleRow } from '../SettingsRows';

const DEFAULTS = { 'ui.users.allow_registration': 'false', 'ui.users.require_invite': 'true' };

// The real user list lives behind /api/me's is_admin and the registration
// gate - until a full user-management API exists, this tab persists the
// registration policy and shows the current admin. No mock rows.
export function UsersTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);
    return (
        <>
            <Section title="Registration">
                <ToggleRow
                    label="Allow new accounts"
                    desc="Anyone reaching the server can sign up. Note: the server only accepts the very first account regardless."
                    value={prefs['ui.users.allow_registration'] === 'true'}
                    onChange={(v) => save({ 'ui.users.allow_registration': String(v) })}
                />
                <ToggleRow
                    label="Require invite code"
                    desc="New accounts need a code from you."
                    value={prefs['ui.users.require_invite'] === 'true'}
                    onChange={(v) => save({ 'ui.users.require_invite': String(v) })}
                />
                <ActionRow label="Invite code" desc="Single use, valid for 7 days." actionLabel="Generate" tone="solid" />
            </Section>
            <Section title="Accounts">
                <div className="settingsFoldersEmpty">Full user management is not wired up yet - accounts are managed in the database.</div>
            </Section>
        </>
    );
}
